import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ProjectSanierungComponent } from './project-sanierung.component';

const routes: Routes = [
  {
    path: '',
    component: ProjectSanierungComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ProjectSanierungRoutingModule { }
